import React, { ChangeEvent, useState, useRef, useEffect, forwardRef } from "react";
import { ICompanyInfo } from "../../services/types/LeadRequisitionType";
import { Input, Modal } from "@citi-icg-172888/icgds-react";
import SelectHoc from "../../common/SelectHoc";
import { useData } from "../../services/context/DataContext";
import _ from "lodash";
import DropdownMultipleHoc from "../../common/DropdownMultipleHoc";

interface CompanyBasicInfoProps {
  companyInfo: ICompanyInfo | null;
  onChange: (companyInfo: ICompanyInfo, field: string) => void;
  id?: string;
  errorJurdisction?: string;
  errorBusiness?: string;
}

const CompanyBasicInfo = forwardRef<HTMLDivElement, CompanyBasicInfoProps>(
  ({ companyInfo, onChange, id, errorBusiness }) => {
    const { staticData, setCompanyInfo } = useData();
    const countries = _.keys(staticData.countries);
    const modalRef = useRef<HTMLDivElement>(null);
    const inputRef = useRef<HTMLInputElement>(null);
    const selectRef = useRef<HTMLDivElement>(null);
    const [visible, setVisible] = useState(false);
    const [previousInfo, setPreviousInfo] = useState<any>(companyInfo);
    const [selectHeadQuarter, setSelectHeadQuarter] = useState<string[]>();

    useEffect(() => {
      selectRef.current?.focus();
    }, [companyInfo?.global_ultimate_country_name]);

    const onChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
      const { name, value } = event.target;
      const updatedCompanyInfo = {
        ...companyInfo,
        [name]: value,
      } as ICompanyInfo;
      onChange(updatedCompanyInfo, name);
    };

    // useEffect(() => {
    //   divRef.current?.focus();
    //   // if (window.innerWidth < 768) {
    //   //   window.parent.scroll(0, 0);
    //   // } else {
    //   //   window.parent.scroll({ top: 0, behavior: "smooth" });
    //   // }
    // }, []);

    const handleModal = (optionSelected: any) => {
      if (optionSelected === "Apply") {
        // Apply the new headquarters selection
        const updatedCompanyInfo = {
          ...companyInfo,
          global_ultimate_country_name: selectHeadQuarter,
          industry: "",
          legalNameOfBusiness: "",
          operatedCountry: [],
          salesSize: "",
          website: "",
        } as ICompanyInfo;
        delete updatedCompanyInfo?.isCompanyVCorPEBacked;

        setCompanyInfo(updatedCompanyInfo);
        setPreviousInfo(updatedCompanyInfo);
        setVisible(false);

        updatedCompanyInfo && onChange(updatedCompanyInfo, "global_ultimate_country_name");
      } else {
        const updatedCompanyInfo = {
          ...previousInfo,
        } as ICompanyInfo;
        setVisible(false);
        setCompanyInfo(updatedCompanyInfo);
        updatedCompanyInfo && onChange(updatedCompanyInfo, "global_ultimate_country_name");
      }
      // Ensure focus is returned to the triggering element
      setTimeout(() => {
        selectRef.current?.focus();
      }, 0);
    };

    useEffect(() => {
      const modalElement = document.getElementsByClassName("lmn-modal-centered")[0];
      if (modalElement && window.innerWidth < 768) {
        modalElement.classList.remove("lmn-modal-centered");
        const modalContent: any = document.getElementsByClassName("lmn-modal-content")[0];
        modalContent.style.marginLeft = "7.5%";
        modalContent.style.marginRight = "7.5%";
        modalContent.style.marginTop = "100%";
      }

      if (visible && modalRef.current) {
        const button = modalRef?.current.querySelector(".lmn-btn.lmn-btn-warning") as HTMLElement;
        setTimeout(() => {
          modalRef.current?.focus();
          if (button) {
            button.focus();
          }
          if (window.parent.location.href.includes("contact-us"))
            modalRef.current?.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    }, [visible]);

    const onChangeDdlHandler = (options: string[], ddName: string, onChangeCalled?: boolean) => {
      if (ddName === "global_ultimate_country_name") {
        setVisible(true);
        // Temporarily set the new headquarters selection
        setSelectHeadQuarter(options);
      } else {
        const updatedCompanyInfo = {
          ...companyInfo,
          [ddName]: options,
        } as ICompanyInfo;
        updatedCompanyInfo && onChange(updatedCompanyInfo, ddName);
      }
      if (!onChangeCalled && ddName === "operatedCountry") {
        inputRef.current?.focus();
      }
    };

    const handleModalLabel = () => {
      return (
        <span tabIndex={0}>
          If you select a new country, you need to make changes to your other information.
        </span>
      );
    };

    return (
      <div className=" lmn-dnca-w-s-100 lmn-dnca-w-m-100 lmn-dnca-w-m-60 lmn-dnca-w-l-60 lmn-dnca-w-xl-60">
        <div className="lmn-mb-5">
          <div
            className="lmn-form-group lmn-mb-5"
            ref={selectRef}
            tabIndex={-1} // Make the div focusable
          >
            <label htmlFor="headquarter location" className="label lmn-required">
              Headquarters Location
            </label>
            <SelectHoc
              // ref={selectRef}
              id="global_country"
              label="Headquarters Location"
              options={countries ?? []}
              value={companyInfo?.global_ultimate_country_name ?? ""}
              onChange={(options: any) =>
                onChangeDdlHandler(options, "global_ultimate_country_name")
              }
            />
            {visible && (
              <Modal
                aria-modal="true"
                visible={visible}
                status="warning"
                ref={modalRef}
                aria-label="If you select a new country, you need to
              make changes to your other information."
                title={handleModalLabel()}
                applyText="Make Changes"
                onApply={() => handleModal("Apply")}
                onCancel={() => handleModal("Cancel")}
                closable={false}
              ></Modal>
            )}
          </div>
          <div id="sub-countries" className=" lmn-form-group lmn-mb-5">
            <label className="lmn-text-wrap" htmlFor="operated_country">
              Other countries with Subsidiaries or Affiliates (Optional)
            </label>
            <DropdownMultipleHoc
              id="operated_country"
              isMultiple={true}
              placeholder={"Subsidiaries Countries"}
              label="Other Countries with Subsidiaries or Afiliates (Optional)"
              menuStyle={{ border: "1px solid #255be3", borderRadius: "2px" }}
              options={staticData.jurisdictions}
              onChange={(options: string[] | undefined) =>
                onChangeDdlHandler(options as string[], "operatedCountry", true)
              }
              onApply={(options: string[] | undefined) =>
                onChangeDdlHandler(options as string[], "operatedCountry")
              }
              value={companyInfo?.operatedCountry}
            />
            
          </div>
          <div className="lmn-form-group  lmn-mb-5">
            <label className="lmn-required" htmlFor={id}>
              Company Name
            </label>
            <Input
              ref={inputRef}
              id={id}
              disabled={companyInfo?.isCompanySource_Flag}
              name="legalNameOfBusiness"
              aria-describedby="company_name"
              aria-required={true}
              value={companyInfo?.legalNameOfBusiness ?? ""}
              onChange={onChangeHandler}
            />
            {errorBusiness && (
              <div aria-live="assertive" role="alert" id="company_name">
                <small>{errorBusiness}</small>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
);

export default CompanyBasicInfo;
